import { Trash2, Plus, Sparkles } from 'lucide-react';
import PaymentSection, { Switch } from './PaymentSection';

export const MAX_PROOFS = 5;

/**
 * Prova social (a mesma do PIX, para qualquer mercado): ligada, até 5 textos
 * e o intervalo do ciclo. Só visual: `value` = { enabled, list, interval };
 * `market` nomeia os campos (há um editor por mercado na mesma tela).
 */
export default function SocialProofEditor({ value, onChange, hint, placeholder = 'Prova social', market = 'Brasil' }) {
    const { enabled, list, interval } = value;
    const proofs = list.length ? list : [''];
    const set = (patch) => onChange({ ...value, ...patch });

    const update = (idx, text) => set({ list: proofs.map((p, i) => (i === idx ? text : p)) });
    const remove = (idx) => {
        const next = proofs.filter((_, i) => i !== idx);
        set({ list: next.length ? next : [''] });
    };

    return (
        <PaymentSection
            icon={Sparkles}
            title="Prova social"
            subtitle={hint}
            aside={<Switch checked={enabled} onChange={(on) => set({ enabled: on })} label={`Prova Social (${market})`} />}
        >
            {enabled && (
                <>
                    <div className="flex flex-col gap-2">
                        {proofs.map((proof, idx) => (
                            <div key={idx} className="flex gap-2 items-center">
                                <span className="pset-counter w-4 text-right">{idx + 1}</span>
                                <input
                                    className="input3"
                                    value={proof}
                                    aria-label={`Prova social ${idx + 1} (${market})`}
                                    placeholder={`${placeholder} ${idx + 1}`}
                                    onChange={(e) => update(idx, e.target.value)}
                                />
                                {proofs.length > 1 && (
                                    <button type="button" className="p-1.5 rounded-md hover:bg-white/[0.06]"
                                        onClick={() => remove(idx)} title="Remover" aria-label={`Remover prova social ${idx + 1}`}>
                                        <Trash2 size={14} className="text-red-400" />
                                    </button>
                                )}
                            </div>
                        ))}
                    </div>

                    <div className="mt-3 flex flex-wrap items-center justify-between gap-3">
                        {proofs.length < MAX_PROOFS ? (
                            <button type="button" className="btn-secondary inline-flex items-center"
                                onClick={() => set({ list: [...proofs, ''] })}>
                                <Plus size={14} className="me-2" /> Adicionar
                            </button>
                        ) : <span />}
                        <label className="flex items-center gap-2 text-xs text-white/55">
                            Trocar a cada
                            <input
                                type="number"
                                className="input3 w-20"
                                min={5}
                                aria-label="Intervalo entre ciclos (segundos)"
                                value={interval}
                                onChange={(e) => set({ interval: e.target.value })}
                            />
                            segundos
                        </label>
                    </div>
                </>
            )}
        </PaymentSection>
    );
}
